@if (isInitialized) {
  <div class="navigation-sidebar" [class.opened]="opened">
    <div
      class="navigation-sidebar-menu"
      [class.hidden]="!opened"
      [class.dark-theme]="darkTheme"
      [exclude]="'.header-menu-icon'"
      (clickOutside)="closeMenuIfMobile()">
      @if (isLogoVisible) {
        <a class="sidebar-logo-image" [routerLink]="['/dashboard']" aria-label="Go to dashboard">
          <img class="logo-image" [cropImage]="headerLogo | settingsMediaPresignedUrl | async" [additionalOptions]="{ func: 'bound' }" alt="">
        </a>
      }
      <nav class="sidebar-navigation" aria-label="Main navigation">
        @if (isLoggedIn) {
          <div class="sidebar-menu-section-wrapper">
            @if (currentUser) {
              <ul class="mobile-only sidebar-menu-list">
                <li class="sidebar-menu-item" [disableOnOffline]="true">
                  <a
                    class="sidebar-menu-link profile-menu-link"
                    routerLink="/profile/details"
                    routerLinkActive="active-link"
                    aria-label="Open profile"
                    (click)="closeMenuIfMobile()">
                    <lib-user-avatar class="d-block" [size]="32" [user]="currentUser"></lib-user-avatar>
                    <div class="profile-information">
                      {{currentUser.name}} {{currentUser.lastName}}
                      @if (currentUser.email) {
                        <span class="profile-email" ellipsis>
                          {{ currentUser.email }}
                        </span>
                      }
                    </div>
                  </a>
                </li>
              </ul>
            }
            <div class="mobile-only navigation-menu-divider"></div>
            <ul class="sidebar-menu-list">
              <li class="sidebar-menu-item" [disableOnOffline]="true">
                <a
                  routerLink="dashboard"
                  routerLinkActive="active-link"
                  class="sidebar-menu-link"
                  (click)="closeMenuIfMobile()"
                  [matTooltip]="'COMMON.home' | translate"
                  matTooltipPosition="right"
                  matTooltipClass="dark-tooltip"
                  [matTooltipDisabled]="opened">
                  <lib-icon class="link-icon" icon="house"></lib-icon>
                  <span class="menu-link-label">{{ 'COMMON.home' | translate }}</span>
                </a>
              </li>
              @for (item of topNavigationMenu | navigationItems : menuArea.TOP_SIDEBAR | async; track item; let last = $last) {
                <li
                  *displayMenuItem="item.key"
                  class="sidebar-menu-item"
                  [class.space-bottom-link]="last"
                  [disableOnOffline]="!item.availableOffline">
                  <ng-container *ngTemplateOutlet="menuItemTmp; context: { item: item }"></ng-container>
                </li>
              }
              <div class="mobile-only navigation-menu-divider"></div>
            </ul>
          </div>
          <ul class="sidebar-menu-list" [disableOnOffline]="true">
            @for (item of bottomNavigationMenu | navigationItems : menuArea.BOTTOM_SIDEBAR | async; track item; let last = $last) {
              <li
                *displayMenuItem="item.key"
                class="sidebar-menu-item"
                [class.space-bottom-link]="last"
                [disableOnOffline]="!item.availableOffline">
                <ng-container *ngTemplateOutlet="menuItemTmp; context: { item: item }"></ng-container>
              </li>
            }
          </ul>
        } @else {
          <ul class="sidebar-menu-list">
            <li class="sidebar-menu-item">
              <a
                [routerLink]="['/access', 'login']"
                routerLinkActive="active-link"
                class="sidebar-menu-link"
                (click)="closeMenuIfMobile()"
                [matTooltip]="'COMMON.sign_in' | translate"
                matTooltipPosition="right"
                matTooltipClass="dark-tooltip"
                [matTooltipDisabled]="opened">
                <lib-icon class="link-icon" icon="sign-in"></lib-icon>
                <span class="menu-link-label">{{ 'COMMON.sign_in' | translate }}</span>
              </a>
            </li>
            @if (registrationEnabled) {
              <li class="sidebar-menu-item">
                <a
                  [routerLink]="['/access', 'register']"
                  routerLinkActive="active-link"
                  class="sidebar-menu-link"
                  (click)="closeMenuIfMobile()"
                  [matTooltip]="'COMMON.create_account' | translate"
                  matTooltipPosition="right"
                  matTooltipClass="dark-tooltip"
                  [matTooltipDisabled]="opened">
                  <lib-icon class="link-icon" icon="plus-circle"></lib-icon>
                  <span class="menu-link-label">{{ 'COMMON.create_account' | translate }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </nav>
    </div>
  </div>
  <div class="navigation-sidebar-overlay" [class.overlay-visible]="opened"></div>
}


<ng-template #menuItemTmp let-item="item">
  <a
    [navigationElement]="item"
    [extendedRouterLink]="item.path"
    [pageId]="item.pageId"
    extendedRouterLinkActive="active-link"
    class="sidebar-menu-link"
    [ngClass]="item.cssClass || ''"
    (click)="closeMenuIfMobile()"
    [matTooltip]="item.title | translate"
    matTooltipPosition="right"
    matTooltipClass="dark-tooltip"
    [matTooltipDisabled]="opened">

    <div class="icon-with-counter">
      @if (item.iconUrl || item.iconMedia) {
        <lib-svg-icon class="link-icon svg-icon" [url]="item.iconUrl || item.iconMedia?.uri"></lib-svg-icon>
      }
      @if (item.icon) {
        <lib-icon class="link-icon" [icon]="item.icon"></lib-icon>
      }

      @if (item.counter; as counter) {
        <div class="icon-counter">
          {{ counter > 9 ? '9+' : counter }}
        </div>
      }
    </div>

    <span class="menu-link-label">{{ item.title | translate }}</span>

    @if (item.availableOffline) {
      <label class="offline-mode-indicator" *ngIfOffline="false">{{'COMMON.offline' | translate }}</label>
    }
  </a>
</ng-template>
